module.exports = __webpack_public_path__ + "static/media/banner_minesweeper-half.af957d21.png";